import * as entitiesUtils from "./entitiesUtils";
import { s3 } from "../../resources/config";
import { cleanSearchNames } from "../../components/HomePage/HomePageSearch/searchResultsPreparation";
import i18n from "../../i18n/config";

/* Preparing business entity - adding full categories tags and add missing fields */
export function prepareCompany(company, companyCategories) {
  const preparedCompany = JSON.parse(JSON.stringify(company));
  preparedCompany.logo = company.logo ? s3 + company.logo : "";

  preparedCompany.subCategories = entitiesUtils.prepareFullCategories(
    company.categories ? company.categories : company.prod_business_sub,
    companyCategories
  );

  preparedCompany.search_names = [...cleanSearchNames(company.search_names), ...preparedCompany.subCategories.map(r => cleanSearchNames(r.search_names)).flat()];


  let sortedProducts = []
  if (company.products?.length > 0) {
      sortedProducts = companyCategories.reduce((acc, category) => {
          const filteredProducts = company.products.filter(product => product.prod_business_sub.includes(category.id));
          if (filteredProducts.length > 0) {
              acc.push({
                  name: companyCategories.find(c => c.id == category.id)?.category_name,
                  products: filteredProducts
              });
          }
          return acc;
      }, []);

      // Collect products not matched to any subcategory into a fallback group
      const categorizedProductIds = new Set(sortedProducts.flatMap(group => group.products.map(p => p.id)));
      const uncategorizedProducts = company.products.filter(p => !categorizedProductIds.has(p.id));
      if (uncategorizedProducts.length > 0) {
          sortedProducts.push({
              name: i18n.t("other_products"),
              products: uncategorizedProducts
          });
      }
  }

  preparedCompany.catalog = sortedProducts;

  preparedCompany.has_discount =
    company.discount_list &&
    company.discount_list.length > 0;

  return preparedCompany;
}
